<template>
  <div>
    <v-row
      class="align-center justify-start mx-0"
      style="background-color:#f5f5f5; position:fixed; z-index: 10; min-width: -webkit-fill-available;"
    >
      <v-row>
        <v-col cols="5">
          <span
            class="text-start"
            style="color:#777; font-size:14px;"
          >CREAR COLA</span>
        </v-col>
        <v-spacer />

        <v-col cols="1" style="min-width: fit-content;" class="pa-1">
          <v-btn icon color="admiraFontGray" class="py-0 my-0" style="margin-left:-35px;">
            <v-icon style="cursor: pointer; font-size:16px" @click="closeRightMenu">mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-row>

    <v-container>
      <v-row class="row align-center justify-center pl-4 pr-4 pb-12" style="margin-top: -60px">
        <v-col cols="12">
          <v-form class ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" style="margin: 0 0 50px 0;margin-top: 90px">

                <v-text-field
                  @input="hideAlertNameQueue"
                  label="Nombre"
                  v-model="objQueue.name"
                  dense
                  required
                  maxlength="40"
                  :hint="objQueue.name ? `${objQueue.name.length}/40` : ''"
                ></v-text-field>
                <v-alert
                  v-if="showAlertName"
                  dense
                  elevation="0"
                  class="text-left"
                  style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                >Necesita un nombre la cola</v-alert>
           
                <v-select
                @input="hideAlertTypeQueue"
                v-model="objQueue.type"
                :items="types"
                item-text="type"
                item-value="idType"
                label="Tipo"
                required
                ></v-select>
                <v-alert
                  v-if="showAlertType"
                  dense
                  elevation="0"
                  class="text-left"
                  style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                >El campo Tipo es obligatorio.</v-alert>

                <v-select
                  @input="hideAlertSpaceQueue"
                  v-model="objQueue.space"
                  :items="allSpacesNew"
                  @change="getAsociatedResources(objQueue.space)"
                  item-text="name"
                  item-value="idSpace"
                  label="Sitio"
                  required
                ></v-select>
                <v-alert
                  v-if="showAlertSpace"
                  dense
                  elevation="0"
                  class="text-left"
                  style="font-size: 12px; color:red; margin-left:-15px; margin-top:-12px"
                >El campo Sitio es obligatorio.</v-alert>

                <v-select 
                  v-if="asociatedSpaces.length > 0 "
                  v-model="objQueue.resources"
                  :items="asociatedSpaces"
                  item-text="name"
                  item-value="idResource"
                  label="Recurso"
                  multiple
                  chips
                ></v-select>

                <v-text-field
                  style="margin: 0 0 10px 0;"
                  v-model="objQueue.description"
                  label="Descripción"
                  required
                  width="200"
                  dense
                  maxlength="100"
                  :hint="objQueue.description ? `${objQueue.description.length}/100` : ''"
                ></v-text-field>

                <hollow-dots-spinner
                  v-if="loading"
                  style="display: inline-block"
                  :animation-duration="2000"
                  :dot-size="15"
                  :dots-num="5"
                  :color="'#689840'"
                />

              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>

      <div style="position: fixed; bottom: 0;background-color: white; width: 100%;">
        <v-divider style="mx-0"></v-divider>

        <v-row class="mb-2 pr-6">

          <v-col cols="6">
            <v-btn
              @click="loading ? false : addNewQueue(objQueue)"
              class="justify-center"
              rounded
              depressed
              color="admiraGreen"
              small
              dark
              width="120"
            >Añadir</v-btn>
          </v-col>
        </v-row>
      </div>
    </v-container>

  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState, mapMutations } from "vuex";
import { HollowDotsSpinner } from "epic-spinners";

export default {
  name: "RightMenuNewDevices",
  data: () => ({
    typeQueueModel: "",
    types: [
      { type: 'Fila única', idType: 1 },
      { type: 'Fila única con tiquets', idType: 2 },
      { type: 'Fila multipuesto con tiquets', idType: 3 },
    ],
    allSpacesModel: "",
    isSaving: false,
    deleteDialog: false,
    show: true,
    loading: false,
    valid: false,
    showAlertType: false,
    showAlertSpace: false,
    showAlertName: false,

  }),
  components: { HollowDotsSpinner },
  computed: {
    ...mapState("queues", [ "spaceSelected","showRightMenu","objQueue", "allSpaces","asociatedSpaces"]),
        ...mapState("app", ["actualProject"]),

  allSpacesNew(){
    let newSpaces = []

    this.allSpaces.forEach(element => {
      if (element.idSpace == this.spaceSelected.idSpace) { 
        newSpaces.push(element)
      }
    });
    
    return newSpaces
  },

  },
  methods: {
    ...mapMutations("queues", [
      "closeRightMenuMutation",
    ]),
    ...mapActions("queues", [
      "addQueueStore","getAsociatedResourcesStore","getAllQueues"
    ]),
    
    hideAlertNameQueue() {
      if (this.objQueue.name != "") {
        this.showAlertName = false;
      }
    },
    hideAlertTypeQueue() {
      if (this.objQueue.type != undefined) {
        this.showAlertType = false;
      }
    },
    hideAlertSpaceQueue() {
      if (this.objQueue.space != undefined) {
        this.showAlertSpace = false;
      }
    },
    async addNewQueue(data) {
      
      if(this.objQueue.name == "" ||this.objQueue.name == undefined){
        this.showAlertName = true;
      } 
      if(this.objQueue.type == undefined){
        this.showAlertType = true;
       }
      if(this.objQueue.space == undefined){
        this.showAlertSpace = true;
      }
      if (this.showAlertName == false && this.showAlertType == false && this.showAlertSpace == false ) {
        let idProject = this.actualProject.id;
        data.project = idProject;
        this.addQueueStore(data);
        await this.closeRightMenuMutation();
        await this.getAllQueues(idProject);
      }
        
    },
    getAsociatedResources(data){
      this.getAsociatedResourcesStore(data);
      this.objQueue.resources = [];
    },
   
    closeRightMenu() {      
      this.closeRightMenuMutation();
    }
  },
  created() {
    
  },
  mounted() {
    
  },
  destroyed() {
    
  }
};
</script>

<style scoped>
>>> .v-navigation-drawer {
  width: 418px !important;
}

.newtext {
  font-family: "Roboto", sans-serif;
}
a {
  text-decoration: none;
}
.admira-icon {
  font-family: "Admira icons";
}
.boxImage {
  background-color: #f5f5f5;
  height: 255px;
  padding: 110px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/RightMenuAddNewQueue.vue